import { registerPlugin } from '@capacitor/core';
const GOOGLE_OFFLINE_REFRESH_MESSAGE = "Google refresh() is not available when using offline mode. Offline mode only returns serverAuthCode for backend token exchange. Send serverAuthCode to your backend and refresh tokens there, or switch google.mode to 'online' for client-side refresh.";
const rawSocialLogin = registerPlugin('SocialLogin', {
    web: () => import('./web').then((m) => new m.SocialLoginWeb()),
});
class SocialLoginClient {
    constructor() {
        this.initialize = this.initialize.bind(this);
        this.refresh = this.refresh.bind(this);
    }
    async initialize(options) {
        await rawSocialLogin.initialize(options);
        this.initializeOptions = options;
    }
    async login(options) {
        return rawSocialLogin.login(options);
    }
    async logout(options) {
        return rawSocialLogin.logout(options);
    }
    async isLoggedIn(options) {
        return rawSocialLogin.isLoggedIn(options);
    }
    async getAuthorizationCode(options) {
        return rawSocialLogin.getAuthorizationCode(options);
    }
    async refresh(options) {
        var _a, _b;
        if (options.provider === 'google' && ((_b = (_a = this.initializeOptions) === null || _a === void 0 ? void 0 : _a.google) === null || _b === void 0 ? void 0 : _b.mode) === 'offline') {
            console.warn(`[SocialLogin] ${GOOGLE_OFFLINE_REFRESH_MESSAGE}`);
        }
        return rawSocialLogin.refresh(options);
    }
    async refreshToken(options) {
        return rawSocialLogin.refreshToken(options);
    }
    async handleRedirectCallback() {
        return rawSocialLogin.handleRedirectCallback();
    }
    async decodeIdToken(options) {
        return rawSocialLogin.decodeIdToken(options);
    }
    async getAccessTokenExpirationDate(options) {
        return rawSocialLogin.getAccessTokenExpirationDate(options);
    }
    async isAccessTokenAvailable(options) {
        return rawSocialLogin.isAccessTokenAvailable(options);
    }
    async isAccessTokenExpired(options) {
        return rawSocialLogin.isAccessTokenExpired(options);
    }
    async isRefreshTokenAvailable(options) {
        return rawSocialLogin.isRefreshTokenAvailable(options);
    }
    async providerSpecificCall(options) {
        return rawSocialLogin.providerSpecificCall(options);
    }
    async getPluginVersion() {
        return rawSocialLogin.getPluginVersion();
    }
    async openSecureWindow(options) {
        return rawSocialLogin.openSecureWindow(options);
    }
}
export const SocialLoginBase = rawSocialLogin;
export const SocialLogin = new SocialLoginClient();
//# sourceMappingURL=social-login.js.map